const roleConstant = {
  ADMIN: 'admin',
  USER: 'user',
}

module.exports = roleConstant
